module.exports = __webpack_public_path__ + "media/images/apple_health/fitness-c70b3a484b5b5b0475b077f5b3bfc77a.svg";